import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Cell,
  ResponsiveContainer,
} from 'recharts'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { formatKilos } from '@/lib/utils'
import type { MonthlyTrendPoint } from '@/types'

interface Props {
  data: MonthlyTrendPoint[] | undefined
  isLoading: boolean
}

export function MonthlyTrendChart({ data, isLoading }: Props) {
  const chartData = (data ?? []).map((d) => ({
    ...d,
    label: d.month_label.slice(0, 6),
  }))

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-sm font-medium">
          Tendencia mensual — últimos 12 meses
          <span className="ml-2 inline-block h-3 w-3 rounded-sm bg-[#dff24b] align-middle" />
          <span className="ml-1 text-xs font-normal text-muted-foreground">mes anterior</span>
        </CardTitle>
      </CardHeader>
      <CardContent>
        {isLoading ? (
          <div className="h-64 animate-pulse rounded-md bg-gray-100" />
        ) : (
          <ResponsiveContainer width="100%" height={260}>
            <BarChart data={chartData} margin={{ bottom: 8 }}>
              <XAxis dataKey="label" tick={{ fontSize: 10 }} />
              <YAxis tickFormatter={(v) => formatKilos(v)} tick={{ fontSize: 11 }} />
              <Tooltip
                formatter={(v) => [formatKilos(v as number), 'kg']}
              />
              <Bar dataKey="kg" radius={[4, 4, 0, 0]}>
                {chartData.map((d, i) => (
                  <Cell key={i} fill={d.is_previous_month ? '#dff24b' : '#7c8c43'} />
                ))}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        )}
      </CardContent>
    </Card>
  )
}
